module.exports = __webpack_public_path__ + "static/img/z2.7d0f864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z2.png
// module id = IvTI
// module chunks = 1